




















import { store } from "@/store";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Cost, ItemDef } from '@/App.vue';

@Component
export default class Item extends Vue {
  @Prop() private definition!: ItemDef;
  @Prop() private ownedQty!: number;

  buy()
  {
    store.purchaseItem(this.definition.id, this.currentCost);
  }

  sell()
  {
    store.sellItem(this.definition.id, this.prevCost);
  }

  get effectStr()
  {
    let str = [];

    if (this.definition.runningCost)
      for (let [resource, amount] of Object.entries(this.definition.runningCost))
        str.push(`-${amount} ${resource}/sec`);

    if (this.definition.effect.gainResource)
      for (let [resource, amount] of Object.entries(this.definition.effect.gainResource))
        str.push(`+${amount} ${resource}/sec`);

    if (this.definition.effect.gainResourceChance)
      for (let [resource, chance] of Object.entries(this.definition.effect.gainResourceChance))
        str.push(`${chance.toFixed(2)}% chance of ${resource}/sec`);

    return str.join(", ");
  }

  get currentCost()
  {
    let cost = Object.assign({}, this.definition.cost);

    for (let resource of Object.keys(cost))
    {
      for (let i = 0; i < this.ownedQty; i++)
        cost[resource] = Math.pow(cost[resource], this.definition.costFactor);

      cost[resource] = Math.floor(cost[resource]);
    }

    return cost;
  }

  get currentCostStr()
  {
    let currentCost = this.currentCost;

    return Object.entries(currentCost).map(([resource, amt]) => `${amt} ${resource}`).join(', ');
  }

  get prevCost()
  {
    let cost = Object.assign({}, this.definition.cost);

    for (let resource of Object.keys(cost))
    {
      for (let i = 0; i < this.ownedQty - 1; i++)
        cost[resource] = Math.pow(cost[resource], this.definition.costFactor);

      cost[resource] = Math.floor(cost[resource]);
    }

    return cost;
  }

  get prevCostStr()
  {
    let prevCost = this.prevCost;

    return Object.entries(prevCost).map(([resource, amt]) => `${amt} ${resource}`).join(', ');
  }
}
